export const servicios ={
    title : "SERVICIOS",
    textOne:"Los planes de SMG Cells están pensados para brindarte ",
    textTwo: "el mejor servicio con la seguridad y respaldo de Swiss Medical Group."
}